export enum DownloadTab {
  DOWNLOADS = 'download',
}

export interface File {
  itemId: string;
  fileName: string;
  version: number;
  actualFileDownloadApi: string;
  sRestDownloadApi: string;
  hasPermission: boolean;
}

export interface Download extends File {
  email: string;
}

export interface GetDownloadListParams {
  keyword?: string;
}

export interface GetActualFilePathParams {
  styleId: string;
  version: number;
}
